import { render, staticRenderFns } from "./AgingStockModal.vue?vue&type=template&id=fd360e6e&scoped=true"
import script from "./AgingStockModal.vue?vue&type=script&lang=js"
export * from "./AgingStockModal.vue?vue&type=script&lang=js"
import style0 from "./AgingStockModal.vue?vue&type=style&index=0&id=fd360e6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd360e6e",
  null
  
)

export default component.exports